import {
  Mtds,
  ScreenHeader,
  ScreenLayout,
  TopBar,
  AppLayout,
  useAuth,
  SignOutIcon,
  UserIcon
} from 'prove-common'
import { AppLogo } from '../components/app-logo/AppLogo'
import { SideBarLayout } from '../components/side-bar-layout/SideBarLayout'

export const SettingsScreen = () => {
  const { accountName, logout } = useAuth()

  return (
    <AppLayout
      isFullWidth
      useMobileBar={false}
      sidebar={<SideBarLayout />}
      topBar={<TopBar logo={<AppLogo />} title='Innstillinger' />}
    >
      <ScreenLayout
        header={
          <ScreenHeader
            title='Innstillinger'
            description={
              <p>Se hvilken konto du er logget inn med, eller logg ut.</p>
            }
          />
        }
      >
        <Mtds.Grid data-gap='5'>
          <Mtds.Heading as='h2' data-size='sm'>
            Din konto
          </Mtds.Heading>
          <Mtds.Flex data-align='center' data-justify='space-between'>
            <Mtds.Info data-variant='circle'>
              <UserIcon aria-hidden />
              <strong>Innlogget som</strong>
              {accountName?.trim() || 'Kontonavn er ikke tilgjengelig'}
            </Mtds.Info>
            <Mtds.Button
              type='button'
              data-variant='secondary'
              onClick={logout}
            >
              <SignOutIcon aria-hidden />
              Logg ut
            </Mtds.Button>
          </Mtds.Flex>
        </Mtds.Grid>
      </ScreenLayout>
    </AppLayout>
  )
}
